import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { apiService } from './services/ApiService';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Garantir que o apiService está disponível antes de inicializar
if (!apiService || typeof apiService.initialize !== 'function') {
  console.error('apiService não está disponível ou não tem o método initialize');
} else {
  // Inicializar o ApiService
  apiService.initialize();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <NotificationProvider>
            <App />
          </NotificationProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
